import { TSvgProps } from '@r1-frontend/ui-react/components/svg/createSvg';
import One from '@r1-frontend/ui-react/components/svg/numbers/One';
import Two from '@r1-frontend/ui-react/components/svg/numbers/Two';

import * as ST from './styled';

type TTextBlockProps = {
    Icon: (props: TSvgProps) => JSX.Element,
    text: string,
};

const TextBlock = ({ Icon, text }: TTextBlockProps) => (
  <ST.TextBlock>
      <Icon type={'white'} />
      <ST.Paragraph $smaller dangerouslySetInnerHTML={{ __html: text }} />
  </ST.TextBlock>
);

export const getSubscriptionInfo = (subscriptionTitle?: string) => {
  const baseString = 'Смотрите кино и&nbsp;сериалы';
  const defaultValueTwo = 'Для этого войдите в&nbsp;приложение или на&nbsp;сайт Movix по&nbsp;номеру телефона или номеру договора Дом.ру с&nbsp;активной подпиской.';

  const texts: Record<string, JSX.Element> = {
    'Иви': (
      <>
        <TextBlock Icon={One} text={`
            ${baseString} по&nbsp;подписке Иви на&nbsp;ТВ-приставке Movix, в&nbsp;приложении Movix для Android&nbsp;TV, в&nbsp;сервисах Иви.
            Для просмотра на&nbsp;сайте или в&nbsp;мобильном приложении Иви войдите в&nbsp;личный кабинет по&nbsp;номеру телефона, который привязан к&nbsp;договору Дом.ру
            с&nbsp;активной подпиской.`}/>
        <TextBlock Icon={Two} text={`
            Если у&nbsp;вас уже есть подписка на&nbsp;Иви, вы&nbsp;можете подключить её&nbsp;у&nbsp;нас и&nbsp;продолжить пользоваться сервисом по&nbsp;специальной цене.
            При подключении к&nbsp;Дом.ру ваш профиль и&nbsp;рекомендации сохранятся, управление подпиской автоматически перейдёт в&nbsp;Дом.ру.`}/>
      </>
    ),
    'Яндекс Плюс': (
      <>
        <TextBlock Icon={One} text={`
            ${baseString} на&nbsp;Кинопоиске с&nbsp;подпиской Яндекс Плюс&nbsp;&mdash; на&nbsp;ТВ-приставке Movix, в&nbsp;приложении Movix для Android TV&nbsp;или
            через сервис Кинопоиска. Для просмотра на&nbsp;сайте или в&nbsp;приложении Кинопоиск войдите в&nbsp;Яндекс ID&nbsp;по&nbsp;номеру телефона или электронной
            почте, которые привязаны к&nbsp;договору Дом.ру с&nbsp;активной подпиской.`}/>
        <TextBlock Icon={Two} text={`
            Если у&nbsp;вас уже есть подписка Яндекс Плюс, вы&nbsp;можете отключить её&nbsp;в&nbsp;личном кабинете Плюса и&nbsp;продолжить пользоваться подпиской
            в&nbsp;Дом.ру, подключив её&nbsp;в&nbsp;личном кабинете Дом.ру. При этом все ваши баллы Плюса и&nbsp;рекомендации сохранятся. Оплачивать Яндекс Плюс можно
            с&nbsp;единого счёта Дом.ру.`}/>
      </>
    ),
    'Дорама': (
      <>
        <TextBlock Icon={One} text={`
            ${baseString} по&nbsp;подписке Дорама на&nbsp;ТВ-приставке Movix, на&nbsp;сайте Movix, в&nbsp;мобильном приложении Movix и&nbsp;в&nbsp;приложении для
            Smart&nbsp;TV.`}/>
        <TextBlock Icon={Two} text={defaultValueTwo}/>
      </>
    ),
    'Пока все спят': (
        <>
          <TextBlock Icon={One} text={`
            Смотрите контент по&nbsp;подписке Пока все спят на&nbsp;приставке Movix, на&nbsp;сайте movix.ru 
            и&nbsp;в&nbsp;приложении Movix для Android.`}/>
          <TextBlock Icon={Two} text={defaultValueTwo}/>
        </>
      ),
      default: (
        <>
          <TextBlock Icon={One} text={`
            ${baseString} по&nbsp;подписке ${subscriptionTitle} на&nbsp;приставке Movix, на&nbsp;сайте movix.ru и&nbsp;в&nbsp;приложении Movix для смартфона
            и&nbsp;Smart TV. Для этого просто введите номер договора и&nbsp;пароль от&nbsp;личного кабинета Дом.ру или войдите в&nbsp;Movix по&nbsp;номеру телефона.`}/>
          <TextBlock Icon={Two} text={`
            Если у&nbsp;вас уже есть подписка на&nbsp;сервис ${subscriptionTitle}, вы&nbsp;можете отменить её&nbsp;в&nbsp;личном
            кабинете и&nbsp;продолжить пользоваться подпиской, купленной у&nbsp;нас.`}/>
        </>
      ),
    };

    if (subscriptionTitle) {
        return texts[subscriptionTitle] || texts.default;
    }
};
